import { LOADER } from './app_types';

export const setLoader = (payload) => ({
    type: LOADER,
    payload
})